import { createContext, useContext, useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const loggedInRef = useRef(false);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback exchanges the session_id first — skip the /me check
    if (window.location.hash?.includes("session_id=")) return;
    // No token yet → treat as logged out without hitting the API (avoids console 401s and the login race window)
    if (!localStorage.getItem("eg_token")) { setUser(false); return; }
    api.get("/auth/me")
      // Don't let a stale mount check overwrite a user set by an in-flight login()
      .then((r) => { if (!loggedInRef.current) setUser(r.data); })
      .catch(() => { if (!loggedInRef.current) setUser(false); });
  }, []);

  const login = (data) => {
    loggedInRef.current = true;
    if (data.token) localStorage.setItem("eg_token", data.token);
    setUser(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed:", e); }
    loggedInRef.current = false;
    localStorage.removeItem("eg_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
